import { useMsal } from "@azure/msal-react";

export const Logout = () => {
  const { instance } = useMsal();

  const logoutHandler = async () => {
    try {
      await instance.logoutRedirect({
        onRedirectNavigate: () => {
          localStorage.removeItem("accessTokenGC");
          return true;
        },
      });
    } catch (error) {
      console.error("Logout failed", error);
    }
  };

  return (
    <button
      title="Logout"
      onClick={logoutHandler}
      style={{
        marginRight: "16px",
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="17"
        height="17"
        viewBox="0 0 17 17"
        fill="none"
      >
        <path
          d="M11.5833 12.4167L15.75 8.25M15.75 8.25L11.5833 4.08333M15.75 8.25H5.75M5.75 0.75H4.75C3.34987 0.75 2.6498 0.75 2.11502 1.02248C1.64462 1.26217 1.26217 1.64462 1.02248 2.11502C0.75 2.6498 0.75 3.34987 0.75 4.75V11.75C0.75 13.1501 0.75 13.8502 1.02248 14.385C1.26217 14.8554 1.64462 15.2378 2.11502 15.4775C2.6498 15.75 3.34987 15.75 4.75 15.75H5.75"
          stroke="white"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </button>
  );
};
